import { RunDownloadImportInput } from '@/models/gen/graphql';
import { RunDownloadImportsDocument } from '@/api/queries';
import graphApi from '@/api';

const [fetchRunDownloadAddonImports] = graphApi(RunDownloadImportsDocument);

const runDownloadAddonImports = async (importId: string) => {
  const input: RunDownloadImportInput = { importIds: [importId] };
  const res = await fetchRunDownloadAddonImports({ input });
  return res?.runDownloadImport?.output;
};

export default runDownloadAddonImports;
